import React, { memo } from "react";
import { useTranslation } from "react-i18next";
import { FormBuilder, formBuilderParams } from "components/FormBuilder/FormBuilder";

const PAGE_LOCALE_KEY = "page.employees.";
const FORM_LABEL_KEY = `${PAGE_LOCALE_KEY}employeeDetail.config.fields`;

const EmployeeTrxConfig = ({ formProps }) => {
  const { t } = useTranslation();

  /** @type {Record<string, import("components/FormBuilder/lib/FormBuilderFieldBuilder").formBuilderFieldConfig>} */
  const fieldsConfig = {
    transactionSale: {
      fieldType: "checkbox",
      fieldName: "transactionSale",
      label: t(`${FORM_LABEL_KEY}.sale`),
    },
    transactionVoid: {
      fieldType: "checkbox",
      fieldName: "transactionVoid",
      label: t(`${FORM_LABEL_KEY}.voidSale`),
    },
    transactionRefund: {
      fieldType: "checkbox",
      fieldName: "transactionRefund",
      label: t(`${FORM_LABEL_KEY}.refund`),
    },
    transactionVoidRefund: {
      fieldType: "checkbox",
      fieldName: "transactionVoidRefund",
      label: t(`${FORM_LABEL_KEY}.voidRefund`),
    },
    transactionAuth: {
      fieldType: "checkbox",
      fieldName: "transactionAuth",
      label: t(`${FORM_LABEL_KEY}.authorization`),
    },
    transactionVoidAuth: {
      fieldType: "checkbox",
      fieldName: "transactionVoidAuth",
      label: t(`${FORM_LABEL_KEY}.voidAuthorization`),
    },
    transactionCapture: {
      fieldType: "checkbox",
      fieldName: "transactionCapture",
      label: t(`${FORM_LABEL_KEY}.authComplete`),
    },
    transactionVoidCapture: {
      fieldType: "checkbox",
      fieldName: "transactionVoidCapture",
      label: t(`${FORM_LABEL_KEY}.voidAuthComplete`),
    },
    transactionVoidVoided: {
      fieldType: "checkbox",
      fieldName: "transactionVoidVoided",
      label: t(`${FORM_LABEL_KEY}.voidVoided`),
    },
    transactionAuthTopUp: {
      fieldType: "checkbox",
      fieldName: "transactionAuthTopUp",
      label: t(`${FORM_LABEL_KEY}.authTopUp`),
    },

    cardVisa: {
      fieldType: "checkbox",
      fieldName: "cardVisa",
      label: t(`${FORM_LABEL_KEY}.cardVisa`),
    },
    cardMaster: {
      fieldType: "checkbox",
      fieldName: "cardMaster",
      label: t(`${FORM_LABEL_KEY}.cardMaster`),
    },
    cardJcb: {
      fieldType: "checkbox",
      fieldName: "cardJcb",
      label: t(`${FORM_LABEL_KEY}.cardJcb`),
    },
    cardCup: {
      fieldType: "checkbox",
      fieldName: "cardCup",
      label: t(`${FORM_LABEL_KEY}.cardCup`),
    },
    cardAmex: {
      fieldType: "checkbox",
      fieldName: "cardAmex",
      label: t(`${FORM_LABEL_KEY}.cardAmex`),
    },

    capEmv: {
      fieldType: "checkbox",
      fieldName: "capEmv",
      label: t(`${FORM_LABEL_KEY}.capEmv`),
    },
    capMag: {
      fieldType: "checkbox",
      fieldName: "capMag",
      label: t(`${FORM_LABEL_KEY}.capMag`),
    },
    capNfc: {
      fieldType: "checkbox",
      fieldName: "capNfc",
      label: t(`${FORM_LABEL_KEY}.capNfc`),
    },
    capPinpad: {
      fieldType: "checkbox",
      fieldName: "capPinpad",
      label: t(`${FORM_LABEL_KEY}.capPinpad`),
    },

    methodCredit: {
      fieldType: "checkbox",
      fieldName: "methodCredit",
      label: t(`${FORM_LABEL_KEY}.methodCredit`),
      mandatory: true,
    },
    methodCash: {
      fieldType: "checkbox",
      fieldName: "methodCash",
      label: t(`${FORM_LABEL_KEY}.methodCash`),
      mandatory: true,
    },
    methodWechat: {
      fieldType: "checkbox",
      fieldName: "methodWechat",
      label: t(`${FORM_LABEL_KEY}.methodWechat`),
      mandatory: true,
    },
    methodAlipay: {
      fieldType: "checkbox",
      fieldName: "methodAlipay",
      label: t(`${FORM_LABEL_KEY}.methodAlipay`),
      mandatory: true,
    },
    methodQRpay: {
      fieldType: "checkbox",
      fieldName: "methodQRpay",
      label: t(`${FORM_LABEL_KEY}.methodQRpay`),
      mandatory: true,
    },
    methodOctopus: {
      fieldType: "checkbox",
      fieldName: "methodOctopus",
      label: t(`${FORM_LABEL_KEY}.methodOctopus`),
      mandatory: true,
    },
    methodQuickpass: {
      fieldType: "checkbox",
      fieldName: "methodQuickpass",
      label: t(`${FORM_LABEL_KEY}.methodQuickpass`),
      mandatory: true,
    },
    methodNFC: {
      fieldType: "checkbox",
      fieldName: "methodNFC",
      label: t(`${FORM_LABEL_KEY}.methodNFC`),
      mandatory: true,
    },
    methodShowQR: {
      fieldType: "checkbox",
      fieldName: "methodShowQR",
      label: t(`${FORM_LABEL_KEY}.methodShowQR`),
      mandatory: true,
    },
    methodScanQR: {
      fieldType: "checkbox",
      fieldName: "methodScanQR",
      label: t(`${FORM_LABEL_KEY}.methodScanQR`),
      mandatory: true,
    }
  }

  return (
    <FormBuilder.Section
      title={t(`${PAGE_LOCALE_KEY}employeeDetail.config.subtitle.transactionConfig`)}
      titleVariant="h3"
      padding={formBuilderParams.formSectionLeftPadding}>
      <FormBuilder.Section
        title={t(`${PAGE_LOCALE_KEY}employeeDetail.config.subtitle.type`)}
        titleVariant="h4">
        <FormBuilder.Row itemsPerRow={3}>
          {FormBuilder.buildFields({
            formProps, fields: [
              fieldsConfig.transactionSale,
              fieldsConfig.transactionVoid,
              fieldsConfig.transactionRefund,
              // fieldsConfig.transactionVoidRefund,
              // fieldsConfig.transactionAuth,
              // fieldsConfig.transactionVoidAuth,
              // fieldsConfig.transactionCapture,
              // fieldsConfig.transactionVoidCapture,
              // fieldsConfig.transactionVoidVoided,
              // fieldsConfig.transactionAuthTopUp,
            ]
          })}
        </FormBuilder.Row>
      </FormBuilder.Section>
      <FormBuilder.Section
        title={t(`${PAGE_LOCALE_KEY}employeeDetail.config.subtitle.acceptedCard`)}
        titleVariant="h4">
        <FormBuilder.Row itemsPerRow={3}>
          {FormBuilder.buildFields({
            formProps, fields: [
              fieldsConfig.cardVisa,
              fieldsConfig.cardMaster,
              // fieldsConfig.cardJcb,
              // fieldsConfig.cardCup,
              // fieldsConfig.cardAmex,
            ]
          })}
        </FormBuilder.Row>
      </FormBuilder.Section>
      <FormBuilder.Section
        title={t(`${PAGE_LOCALE_KEY}employeeDetail.config.subtitle.entryMode`)}
        titleVariant="h4">
        <FormBuilder.Row itemsPerRow={3}>
          {FormBuilder.buildFields({
            formProps, fields: [
              fieldsConfig.capEmv,
              fieldsConfig.capMag,
              fieldsConfig.capNfc,
              // fieldsConfig.capPinpad,
            ]
          })}
        </FormBuilder.Row>
      </FormBuilder.Section>
      <FormBuilder.Section
        title={t(`${PAGE_LOCALE_KEY}employeeDetail.config.subtitle.displayMethod`)}
        titleVariant="h4">
        <FormBuilder.Row itemsPerRow={3}>
          {FormBuilder.buildFields({
            formProps, fields: [
              fieldsConfig.methodCredit,
              // fieldsConfig.methodCash,
              fieldsConfig.methodWechat,
              fieldsConfig.methodAlipay,
              fieldsConfig.methodQRpay,
              fieldsConfig.methodOctopus,
              // fieldsConfig.methodQuickpass,
              // fieldsConfig.methodNFC,
              fieldsConfig.methodShowQR,
              fieldsConfig.methodScanQR,
            ]
          })}
        </FormBuilder.Row>
      </FormBuilder.Section>
    </FormBuilder.Section>
  );
};

export default memo(EmployeeTrxConfig);
